import { AutenticacionService } from '../autenticacion.service';
import { Http, URLSearchParams, ResponseContentType } from '@angular/http';
import { ConstantsService } from '../constants.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ReportesCarteraService {

  private service_url : string = '';
  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService) {
    this.service_url = this.constantsService.apiURL + '/reportes/cartera';
  }

  public general(filters : any, download: boolean = false) {
    let myParams = new URLSearchParams();
    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();   
    myoptions.params = myParams; 
    let serviceUrl = this.service_url + '/general';

    if(download){
      myoptions.responseType = ResponseContentType.Blob;
      serviceUrl = this.service_url + '/general/export';
    }
    
    return this.http.get(serviceUrl , myoptions);
  }

  public creditos(filters : any, download: boolean = false) {
    let myParams = new URLSearchParams();

    if(filters.fechaInicio){
      myParams.append('fecha-inicio', filters.fechaInicio);
    }

    if(filters.fechaFin){
      myParams.append('fecha-fin', filters.fechaFin);
    }

    if(filters.tipoCredito){
        myParams.append('tipo_credito', filters.tipoCredito);
    }

    if(filters.riesgo){
      myParams.append('tipo_riesgo', filters.riesgo);
    }

    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }

    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
    
    let serviceUrl = this.service_url + '/creditos';

    if(download){
      myoptions.responseType = ResponseContentType.Blob;
      serviceUrl = this.service_url + '/creditos/export';
    }
    
    return this.http.get(serviceUrl , myoptions);
  }
}


// WEBPACK FOOTER //
// ./src/app/services/reportes/reportes-cartera.service.ts